import axios from "axios";
import queryString from "query-string";

import { mapKeysToSnakeCase } from "../../util/formatHelpers";

export const IDLE = "idle";
export const LOADING = "loading";
export const LOADED = "loaded";
export const ERROR = "error";

export interface MetaPagination {
  current_page: number;
  total_pages: number;
  total_items: number;
  limit_value: number;
  offset_value: number;
  shown_items: number;
}

export const GET = (url: string, params = {}) =>
  axios({
    method: "GET",
    url,
    params,
    paramsSerializer: function (params) {
      return queryString.stringify(mapKeysToSnakeCase(params));
    },
  });

export const POST = (url: string, data) =>
  axios({
    method: "POST",
    url,
    data,
  });

export const PATCH = (url: string, data) =>
  axios({
    method: "PATCH",
    url,
    data,
  });

export const DELETE = (url: string, data) =>
  axios({
    method: "DELETE",
    url,
    data,
  });
